import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';

const UTOpenableRow = ({ style, active, renderComponent, renderActiveComponent }) => (
  <div style={style}>
    {renderComponent(active)}
    {active && renderActiveComponent()}
  </div>
);

UTOpenableRow.propTypes = {
  renderComponent: PropTypes.func.isRequired,
  renderActiveComponent: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired
};

export default Radium(UTOpenableRow);
